<!--
 * @Description: 教学设计 添加 教学日志
 * @Author: ZSC
 * @Date: 2023-04-18 16:56:37.484
 * @LastEditors: PF
 * @LastEditTime: 2025-06-11 17:50:27
-->
<template>
  <div class="list-page pl0 pt0 pr0 pb0">
    <el-container>
      <el-main>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="0px">
          <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#ccc">
            <tbody>
              <tr>
                <td bgcolor="#f4f4f5">班级</td>
                <td>{{ ruleForm.bjmc }}</td>
                <td bgcolor="#f4f4f5">课程名称</td>
                <td>{{ruleForm.kcmc}}（{{ ruleForm.skxsmc }}）</td>
                <td bgcolor="#f4f4f5">授课地点</td>
                <td class="w110">{{ ruleForm.jxcdmc }}</td>
              </tr>
              <tr>
                <td bgcolor="#f4f4f5">节次</td>
                <td colspan="1">星期{{ruleForm.xingqimc}} - 第{{ruleForm.jc}}节（{{ruleForm.rq}} 第{{ruleForm.zc}}周）</td>
                <td bgcolor="#f4f4f5">教师教学计划</td>
                <td colspan="3">
                  <el-select class="hp100 mr10" v-model="ruleForm.xqjxjhid">
                    <el-option v-for="item in jsjxjhData" :key="item.id" :label="item.jxnrbt" :value="item.id">
                    </el-option>
                  </el-select>
                </td>
              </tr>
              <tr v-for="(item,index) in jxrzmbData" :key="index">
                <td bgcolor="#f4f4f5">{{item.tbnr}}</td>
                <td colspan="7" style="text-align: left;">
                  <el-input v-if="lxData.wenben === item.lx" v-model="item.nr" :placeholder="'请输入'+item.tbnr" />
                  <span class="ml10 mr10" v-if="lxData.danxuan === item.lx">
                    <el-radio v-for="(val,v) in item.jxrzxxnrs" :key="v" v-model="val.sfmrz" :label="true" @click="sfmrzClick(index,v)">{{ val.xxnr }}</el-radio>
                  </span>
                  <span class="ml10 mr10" v-if="lxData.duoxuan === item.lx">
                    <el-checkbox v-for="(val,v) in item.jxrzxxnrs" :key="v" v-model="val.sfmrz" :label="false">{{ val.xxnr }}</el-checkbox>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#CCCCCC">
            <tbody>
              <tr>
                <td colspan="2"></td>
                <td :colspan="kqlxData.length" bgcolor="#ecf5ff">学生考勤</td>
                <td :colspan="jllxData.length" bgcolor="#ecf5ff">学生纪律</td>
                <td colspan="1"></td>
              </tr>
              <tr>
                <td colspan="2" bgcolor="#f4f4f5">考勤汇总</td>
                <td v-for="(item, index) in xskqhz" :key="index">{{item.sl}}</td>
                <td v-for="(item, index) in xsjlhz" :key="index">{{item.sl}}</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td bgcolor="#f4f4f5">序号</td>
                <td bgcolor="#f4f4f5">姓名</td>
                <td bgcolor="#f4f4f5" v-for="(item, index) in kqlxData" :key="index">{{item.mbnr}}</td>
                <td bgcolor="#f4f4f5" v-for="(item, index) in jllxData" :key="index">{{item.mbnr}}</td>
                <td bgcolor="#f4f4f5" class="w200">备注</td>
              </tr>
              <tr v-for="(item, index) in bjxsData" :key="index">
                <td bgcolor="#f4f4f5">{{index+1}}</td>
                <td>{{item.xm}}</td>
                <td v-for="(kqItem, kqInd) in kqlxData" :key="kqInd">
                  <div class="gang_wei">
                    <el-radio v-model="item.kqzt" :label="kqItem.id" @change="kaoQinHuiZongChange(kqItem.id, item.id)"></el-radio>
                  </div>
                </td>
                <td v-for="(jlItem, jlInd) in jllxData" :key="jlInd">
                  <div class="gang_wei">
                    <input type="checkbox" :name="item.jlzt" :value="item.jlzt" @click="jiLvHuiZongChange(jlItem.id, item.id)" />
                  </div>
                </td>
                <td><el-input v-model="item.bz" class="wp100 h50" type="textarea" placeholder="请输入备注" resize="none" /></td>
              </tr>
              <tr>
                <td colspan="2" bgcolor="#ecf5ff">备注</td>
                <td :colspan="kqlxData.length+jllxData.length+1"><el-input v-model="ruleForm.bz" class="wp100 h100" type="textarea" placeholder="请输入备注" resize="none" /></td>
              </tr>
            </tbody>
          </table>
        </el-form>
      </el-main>
      <el-footer class="el-dialog__footer">
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" v-if="sfwc" @click="submit(1)">保存</el-button>
            <el-button @click="handleClose">关闭</el-button>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  submitForm,
  closeWindow,
  loadSelect,
  actionPost
} from '@/api/common.js'
import { getjxrzmbtx, getkclb, getZwxq, getKqlx } from '@/utils/meiju.js'
import { findKeyByValue } from '@/utils/shuzu.js'
import { warningPrompt } from '@/utils/promptInfo.js'
const props = defineProps({
  openAdd: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openAdd', 'ReturnData', 'guanBi'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

// 关闭
const handleClose = () => {
  closeWindow('openAdd', emits, true)
  emits('update:openAdd', false)
  emits('guanBi', true)
}
const kclbData = ref(getkclb()) // 课程类别
const jxrzmbData = ref([]) // 教学日志模板
const kqlxData = ref([]) // 考勤类型
const jllxData = ref([]) // 纪律类型
const bjxsData = ref([]) // 班级学生
const jxcdData = ref([]) // 教学场地
const kqztData = ref([]) // 考勤记录状态
const lxData = ref(getjxrzmbtx()) // 类型
const xskqhz = ref([]) // 学生考勤汇总
const xsjlhz = ref([]) // 学生纪律汇总
const ssqjjlData = ref([]) // 学生请假记录
const xsqjllData = ref() // 学生请假类型
const jsjxjhData = ref([]) // 教师教学计划

// 单选
const sfmrzClick = (i, v) => {
  jxrzmbData.value.forEach((element, index) => {
    if (i === index) {
      element.jxrzxxnrs.forEach((ele, e) => {
        if (v === e) {
          ele.sfmrz = true
        } else {
          ele.sfmrz = false
        }
      })
    }
  })
}
// 学生考勤汇总
const kaoQinHuiZongChange = (kqid, xsid) => {
  xskqhz.value.forEach((element) => {
    if (JSON.stringify(element.xsids).indexOf(JSON.stringify(xsid)) === -1) {
      if (element.kqmbid === kqid) {
        element.xsids.push(xsid)
        element.sl = element.sl + 1
      }
    } else {
      element.xsids.forEach((item, i) => {
        if (xsid === item) {
          element.sl = element.sl - 1
          element.xsids.splice(i, 1)
        }
      })
    }
  })
}
// 学生纪律汇总
const jiLvHuiZongChange = (jlid, xsid) => {
  xsjlhz.value.forEach(element => {
    if (element.jlmbid === jlid) {
      if (element.jlzt.length) {
        if (element.jlzt.find(item => item.jlmbid === jlid) && element.jlzt.find(item => item.xsid === xsid)) {
          element.jlzt.forEach((item, i) => {
            if (jlid === item.jlmbid && xsid === item.xsid) {
              element.sl = element.sl - 1
              element.jlzt.splice(i, 1)
            }
          })
        } else {
          element.jlzt.push({ jlmbid: jlid, xsid: xsid })
          element.sl = element.sl + 1
        }
      } else {
        element.jlzt.push({ jlmbid: jlid, xsid: xsid })
        element.sl = element.sl + 1
      }
    }
  })
  bjxsData.value.forEach(element => {
    if (element.id === xsid) {
      if (JSON.stringify(element.jlzts).indexOf(JSON.stringify(jlid)) === -1) {
        element.jlzts.push(jlid)
      } else {
        element.jlzts.forEach((item, i) => {
          if (jlid === item) {
            element.sl = element.sl - 1
            element.jlzts.splice(i, 1)
          }
        })
      }
    }
  })
}

// 学生请假记录
const initbanjilist = () => {
  loadSelect({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/banjilist',
    data: ssqjjlData,
    parms: {
      bjid: ruleForm.value.bjid,
      qjkssj: ruleForm.value.rq + ' ' + ruleForm.value.ksrq,
      qjjssj: ruleForm.value.rq + ' ' + ruleForm.value.jsrq
    },
    loadSuccess: function () {
      initTongBuKaoQin()
    }
  })
}
// 载入学生考勤信息
const initTongBuKaoQin = () => {
  ssqjjlData.value.forEach((element) => {
    bjxsData.value.forEach((item) => {
      // 查找学生信息
      if (item.id === element.xsid) {
        // 获取考勤状态名称
        const kqmc = findKeyByValue(xsqjllData.value, element.qjlxid)
        xskqhz.value.forEach((kqitem) => {
          // 获取考勤状态id kqztData.value[kqmc]
          if (kqitem.kqmbid === kqztData.value[kqmc]) {
            // 当前考勤状态加入该学生
            kqitem.xsids.push(element.xsid)
            kqitem.sl = kqitem.xsids.length
            // 学生中加入考勤状态id（单选按钮显示）
            item.kqzt = kqitem.kqmbid
            item.jlzts = []
          } else {
            // 其他考勤状态删除该学生
            kqitem.xsids.forEach((val, i) => {
              if (element.xsid === val) {
                kqitem.sl = kqitem.sl - 1
                kqitem.xsids.splice(i, 1)
              }
            })
          }
        })
      }
    })
  })
}
const rqInfo = () => {
  // 班级学生
  loadSelect({
    url: '/api/v2/jiaowu/jiaoshijiaoxuerizhi/banjilist',
    data: bjxsData,
    parms: {
      order: 'xh',
      sort: 'asc',
      xlbjkbid: ruleForm.value.kbid
    },
    loadSuccess: function (res) {
      res.data.map((item) => {
        item.kqzt = kqlxData.value.find((item) => item.sx === 1).id
        item.jlzts = []
        return item
      })
      xskqhz.value.forEach((element) => {
        element.xsids = []
        if (element.kqmbid === kqlxData.value.find((item) => item.sx === 1).id) {
          res.data.forEach((item) => {
            if (
              item.kqzt === kqlxData.value.find((item) => item.sx === 1).id
            ) {
              element.xsids.push(item.id)
            }
          })
          element.sl = element.xsids.length
        }
      })
    }
  })
  // 获取日期
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: { xqid: ruleForm.value.xqid, xq: ruleForm.value.xq, zc: ruleForm.value.zc }
  }).then((res) => {
    if (res.code === 200) {
      ruleForm.value.rq = res.data[0].rq
      initbanjilist()
    } else {
      warningPrompt(res.message)
    }
  })
  // 授课方式
  kclbData.value.list.forEach((element) => {
    if (element.value === ruleForm.value.skxs) {
      ruleForm.value.skxsmc = element.name
    }
  })
  // 课程教学场地
  loadSelect({
    url: '/api/v2/zichan/jiaoxuechangdi/list',
    data: jxcdData,
    order: 'jsbh',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.id === ruleForm.value.jxcdid) {
          ruleForm.value.jxcdmc = element.jsmc
        }
      })
    }
  })
  // 教学日志模板
  loadSelect({
    url: '/api/v2/jiaowu/jiaoxuerizhimuban/list',
    data: jxrzmbData,
    parms: { kcid: ruleForm.value.kcid },
    loadSuccess: function (res) {
      for (const i in res.data) {
        for (const j in res.data[i]) {
          if (j === 'xztxxs') {
            res.data[i].jxrzxxnrs = res.data[i][j] // 修改属性名为“jxrzxxnrs”
            delete res.data[i].xztxxs // 删除“xztxxs”
          }
        }
      }
      jxrzmbData.value = res.data
    }
  })
  // 教师教学计划
  loadSelect({
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/dangqianjiaoshilist',
    data: jsjxjhData,
    parms: {
      xqid: ruleForm.value.xqid,
      bjid: ruleForm.value.bjid,
      kcid: ruleForm.value.kcid
    },
    loadSuccess: function (res) {
      jsjxjhData.value = res.data.map(item => {
        item.jxnrbt = item.jxnrbt || ' '
        return item
      })
    }
  })
  // 学生请假类型
  loadSelect({
    url: '/api/v2/jiaowu/xueshengqingjiajilu/xueshengqinjialeixing',
    data: xsqjllData
  })
  // 考勤记录类型
  loadSelect({
    url: '/api/v2/jiaowu/kaoqinjilumuban/list',
    data: kqlxData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      kqlxData.value = []
      jllxData.value = []
      res.data.forEach((element) => {
        if (element.lx === getKqlx().kaoqin) {
          const obj = { kqmbid: element.id, sx: element.sx, sl: 0, xsids: [] }
          xskqhz.value.push(obj)
          kqlxData.value.push(element)
        }
        if (element.lx === getKqlx().jilv) {
          const obj = { jlmbid: element.id, sx: element.sx, sl: 0, jlzt: [] }
          xsjlhz.value.push(obj)
          jllxData.value.push(element)
        }
      })
    }
  })
  // 考勤记录状态
  loadSelect({
    url: '/api/v2/jiaowu/jiaoshijiaoxuerizhi/kaoqinjiluzhuangtai',
    data: kqztData,
    order: 'sx',
    sort: 'asc'
  })
}
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      ruleForm.value.dbgzid = props.row.chechboxtrue.id
      ruleForm.value.xqid = props.row.xqid
      ruleForm.value.xq = props.row.chechboxtrue.xq
      ruleForm.value.xingqimc = getZwxq(props.row.chechboxtrue.xq)
      ruleForm.value.zc = props.row.zc
      ruleForm.value.skxs = props.row.chechboxtrue.kclb
      ruleForm.value.jxcdid = props.row.chechboxtrue.jxcdids
        ? props.row.chechboxtrue.jxcdids[0]
        : ''
      ruleForm.value.kcid = props.row.chechboxtrue.kcid
      ruleForm.value.kcmc = props.row.chechboxtrue.kcmc
      ruleForm.value.bjid = props.row.chechboxtrue.bjid
      ruleForm.value.bjmc = props.row.chechboxtrue.bjmc
      ruleForm.value.jsrq = props.row.chechboxtrue.jssj
      ruleForm.value.jsid = props.row.chechboxtrue.jsid
      ruleForm.value.kbid = props.row.chechboxtrue.xlbjkbid
      ruleForm.value.jc = props.row.chechboxtrue.jc
      ruleForm.value.ksrq = props.row.chechboxtrue.kssj

      rqInfo()
    }
  },
  { deep: true, immediate: true }
)

// 提交
const sfwc = ref(true)
const submit = async (val) => {
  ruleForm.value.zt = val
  ruleForm.value.kssj = ruleForm.value.rq + ' ' + ruleForm.value.ksrq
  ruleForm.value.jssj = ruleForm.value.rq + ' ' + ruleForm.value.jsrq
  // 教学日志内容
  ruleForm.value.jxrznrs = jxrzmbData.value.map((item) => {
    item.mbzdmc = item.tbnr
    return item
  })
  // 教学日志考勤记录
  ruleForm.value.jxrzkqjls = bjxsData.value.map((item) => ({
    xsid: item.id,
    kqmbid: item.kqzt,
    jlmbids: item.jlzts,
    bz: item.bz
  }))
  // 学生考勤汇总
  ruleForm.value.kqhz = xskqhz.value.map((item) => ({
    kqmbid: item.kqmbid,
    sl: item.sl
  }))
  // 学生纪律汇总
  ruleForm.value.jlhz = xsjlhz.value.map((item) => ({
    jlmbid: item.jlmbid,
    sl: item.sl
  }))
  submitForm({
    url: '/api/v2/jiaowu/jiaoshijiaoxuerizhi',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      sfwc.value = false
    }
  })
}
</script>
<style lang="less" scoped>
:deep(.el-form-item) {
  margin: 18px 10px !important;
}
:deep(td) {
  text-align: center;
  height: 35px;
  min-width: 50px;
}
.el-textarea__inner {
  min-height: 100%;
}
:deep(.select-trigger),
:deep(.el-input) {
  height: 100%;
}
:deep(.xue-sheng-kao-qin) {
  height: 50px;
  :deep(td) {
    height: 50px;
  }
}
:deep(.gang_wei .el-radio__label) {
  display: none;
}
:deep(.el-textarea__inner) {
  min-height: 100% !important;
  height: 100%;
}
</style>
